"use strict";
/**
 * TypeScript port by Ikaros Kappler.
 *
 * Original file from https://github.com/AlloyTeam/AlloyFinger
 *
 * @date 2021-02-10
 */
Object.defineProperty(exports, "__esModule", { value: true });
var alloy_finger_1 = require("./alloy_finger");
exports.default = alloy_finger_1.AlloyFinger;
//# sourceMappingURL=index.js.map